/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

  // Clear delivery date attribute when cart is empty
  function clearDeliveryDateIfCartEmpty() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count === 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Delivery date': '' } })
          }).then(() => console.log('Delivery date attribute cleared'));
        }
      });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', clearDeliveryDateIfCartEmpty);

  // Run whenever cart is updated (covers Ajax cart themes)
  document.addEventListener('cart:updated', clearDeliveryDateIfCartEmpty);
  document.addEventListener('cart:refresh', clearDeliveryDateIfCartEmpty);
  document.addEventListener('cart-update', clearDeliveryDateIfCartEmpty);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
